import {Component} from "vue";
import {PortalContext} from "@hantera/portal-app";

interface ViewRegistration {
  accessPatterns?: string[]
  component: any
  props: Record<string, any>
}

const viewMap: Map<string, ViewRegistration> = new Map<string, ViewRegistration>()

export interface GetViewResult
{
  state: 'found' | 'notFound' | 'unauthorized'
  component?: Component
  props?: Record<string, any>
}

export function getView(context: PortalContext, path: string): GetViewResult | undefined {
  
  const hit = viewMap.get(path);
  
  if (!hit) {
    return {
      state: 'notFound'
    }
  }
  
  if (!context.authorizeAll(hit.accessPatterns))
  {
    return {
      state: 'unauthorized'
    }
  }

  return {
    state: 'found',
    component: hit.component,
    props: hit.props
  }
}

export function registerView(path: string, component: Component, accessPatterns?: string[], props: Record<string, any> = {}): void {
  
  if (props.is || props.key) {
    throw `Cannot register view, 'is' and 'key' are reserved props`
  }
  
  viewMap.set(path, {
    accessPatterns,
    component,
    props
  })
}